export default __webpack_public_path__ + "static/media/callout_aerial.7bb6ada6.svg";